import React from 'react';

export function Section({
    children,
    width = 'lg',
    tight = false,
    className = '',
    ...rest
}: {
    children: React.ReactNode;
    width?: 'md' | 'lg' | 'xl';
    tight?: boolean;
    className?: string;
} & React.HTMLAttributes<HTMLElement>) {
    return (
        <section className={['ds-section', tight ? 'ds-section--tight' : '', className].filter(Boolean).join(' ')} {...rest}>
            <div className={['ds-container', width !== 'lg' ? `ds-container--${width}` : ''].filter(Boolean).join(' ')}>{children}</div>
        </section>
    );
}
